import App from '../app';
import magyarsag from './magyarsag';
import '../../css/magyarsag.css'

const Modules = {
    magyarsag
}

App.init(Modules);
